'use client'

import type { PropsWithChildren } from 'react'
import { useEffect, useMemo } from 'react'
import { usePathname } from 'next/navigation'
import { PagePerformanceLifecycleContext } from '@/hooks/usePagePerformanceLifecycle'
import { DefaultPagePerformanceLifecycle } from '@/lib/page-performance/DefaultPagePerformanceLifecycle'

export default function DefaultPagePerformanceLifecycleHost({
  children,
}: PropsWithChildren) {
  const pathname = usePathname() ?? '/'
  const lifecycle = useMemo(
    () => new DefaultPagePerformanceLifecycle(pathname),
    [pathname]
  )

  useEffect(() => {
    let secondFrame = 0
    const firstFrame = requestAnimationFrame(() => {
      secondFrame = requestAnimationFrame(() => lifecycle.markRenderComplete())
    })

    return () => {
      cancelAnimationFrame(firstFrame)
      cancelAnimationFrame(secondFrame)
      if (process.env.NODE_ENV === 'production') {
        lifecycle.dispose()
      }
    }
  }, [lifecycle])

  return (
    <PagePerformanceLifecycleContext.Provider value={lifecycle}>
      {children}
    </PagePerformanceLifecycleContext.Provider>
  )
}
